import { ArpMedia } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { styled } from '../../../lib/stitches'
import { Box } from '../../core/Components'
import { Loader, PreviewBar } from '../new-explore/components/Table'
import TableRow, { TableRowHeader } from '../new-explore/components/TableRow'
import useSelectedMedia from '../new-explore/hooks/useSelectedMedia'
import useSongs, { DEFAULT_FILTERS } from '../new-explore/hooks/useSongs'

const StyledStickyNavigation = styled('div', {
  backgroundColor: 'white',
  zIndex: 1
})

interface TableProps {
  top: string
}

const CompetitionTable: FC<TableProps> = observer(({ top }) => {
  const { data, hasMore, getNextPage, filters, updateFilters, status } = useSongs({
    ...DEFAULT_FILTERS,
    featured: true
  })
  const queueData = useMemo(() => data.map((item) => item.id), [data])
  const { index, type, handleSelect } = useSelectedMedia({ queueData })
  const order = filters.order
  const orderBy = filters.orderBy
  const handleSortChange = (
    _orderBy: keyof Omit<ArpMedia, 'metadata' | 'subComponents' | 'user'>
  ) => {
    if (orderBy == _orderBy) return updateFilters({ order: order === 'asc' ? 'desc' : 'asc' })
    updateFilters({ orderBy: _orderBy, order: 'desc' })
  }

  return (
    <Box css={{ display: 'flex', alignItems: 'stretch', minHeight: '100vh' }}>
      <Box css={{ flex: 1, position: 'relative' }}>
        <StyledStickyNavigation css={{ position: 'sticky', top }}>
          <TableRowHeader
            order={order}
            orderBy={orderBy}
            onSelect={handleSortChange}
            used={false}
          />
        </StyledStickyNavigation>
        <InfiniteScroll
          dataLength={data.length}
          hasMore={hasMore}
          loader={<Loader />}
          next={getNextPage}
        >
          {data.map((media, i) => (
            <TableRow
              media={media}
              key={media.id}
              onSelect={handleSelect}
              active={media.id === index}
              used={false}
            />
          ))}
        </InfiniteScroll>
      </Box>
      <PreviewBar id={index} type={type} title="Play a song to view the token" />
    </Box>
  )
})

export default CompetitionTable
